module.exports={
	"Form": "ObservationApprovalWorkflowViewManifest",
	"Scope": "ObservationApprovalWorkflow-View",
	"Descriptors":
	{
		"ObservationApprovalWorkflowDetails.IDObservationApprovalWorkflow":
		{
			"Name": "ID",
			"Hash": "ObsWfView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsWfIdentity",
				"Group": "ObsWfIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsWfIdentity",
				"Group": "ObsWfIdentity"
			}
		},
		"ObservationApprovalWorkflowDetails.FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfView-FromStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfView-ToStatus",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfView-IDProject",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ObsWfConfig",
				"Group": "ObsWfConfig"
			}
		},
		"ObservationApprovalWorkflowDetails.EdgeOptions":
		{
			"Name": "Edge Options (JSON)",
			"Hash": "ObsWfView-EdgeOptions",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ObsWfEdgeOptions",
				"Group": "ObsWfEdgeOptions"
			}
		},
		"ObservationApprovalWorkflowDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsWfView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsWfView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsWfView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		},
		"ObservationApprovalWorkflowDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsWfView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsWfAudit",
				"Group": "ObsWfAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsWfIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsWfIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Workflow Configuration",
			"Hash": "ObsWfConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Workflow Configuration",
					"Hash": "ObsWfConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Edge Options",
			"Hash": "ObsWfEdgeOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Edge Options",
					"Hash": "ObsWfEdgeOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsWfAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsWfAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
